import {
  removeCartLineAndWarranty,
  syncCartLineAndWarrantyQuantity,
} from '../lib/cartLineWarrantySync';

const getLineContext = qtyEl => {
  const removeBtn = qtyEl.querySelector('[data-cart-line-remove]');
  const wrapper = qtyEl.closest('[data-cart-qty]') || qtyEl;

  return {
    lineItemKey: wrapper.dataset.lineItemKey || removeBtn?.dataset.lineItemKey,
    warrantyLineItemKey:
      wrapper.dataset.warrantyLineItemKey || removeBtn?.dataset.warrantyLineItemKey,
    parentProductId: Number(
      wrapper.dataset.parentProductId || removeBtn?.dataset.parentProductId
    ),
    removeHref: removeBtn?.href,
  };
};

const setQtyControlsBusy = (qtyEl, busy) => {
  qtyEl.querySelectorAll('button, [data-cart-qty-input]').forEach(control => {
    control.disabled = busy;
  });
};

const reloadCartPage = () => {
  window.location.reload();
};

const initCartLineItemQty = () => {
  const lineItemQtyEls = document.querySelectorAll('[data-cart-qty]');
  if (!lineItemQtyEls.length) return;

  lineItemQtyEls.forEach(qtyEl => {
    if (qtyEl.dataset.cartQtyInit === 'true') return;
    qtyEl.dataset.cartQtyInit = 'true';

    const input = qtyEl.querySelector('[data-cart-qty-input]');
    const btnIncrease = qtyEl.querySelector('[data-cart-qty-increase]');
    const btnDecrease = qtyEl.querySelector('[data-cart-qty-decrease]');
    const removeBtn = qtyEl.querySelector('[data-cart-line-remove]');
    if (!input || !btnIncrease || !btnDecrease) return;

    const applyQuantity = async delta => {
      const context = getLineContext(qtyEl);
      const currentValue = Number(input.value) || 1;
      const newValue = currentValue + delta;

      if (!context.lineItemKey) return;

      setQtyControlsBusy(qtyEl, true);

      try {
        if (newValue < 1) {
          await removeCartLineAndWarranty(context);
        } else {
          await syncCartLineAndWarrantyQuantity({
            ...context,
            quantity: newValue,
          });
          input.value = newValue;
        }

        reloadCartPage();
      } catch (error) {
        console.error('Error updating basket line item quantity:', error);
        if (context.removeHref) {
          window.location.assign(context.removeHref);
        }
      } finally {
        setQtyControlsBusy(qtyEl, false);
      }
    };

    btnIncrease.addEventListener('click', () => {
      applyQuantity(1);
    });

    btnDecrease.addEventListener('click', () => {
      applyQuantity(-1);
    });

    if (!removeBtn || removeBtn.dataset.cartLineRemoveInit === 'true') return;
    removeBtn.dataset.cartLineRemoveInit = 'true';

    removeBtn.addEventListener('click', async event => {
      event.preventDefault();

      const context = getLineContext(qtyEl);
      if (!context.lineItemKey) return;

      setQtyControlsBusy(qtyEl, true);

      try {
        await removeCartLineAndWarranty(context);
        reloadCartPage();
      } catch (error) {
        console.error('Error removing basket line item:', error);
        if (context.removeHref) {
          window.location.assign(context.removeHref);
        }
      } finally {
        setQtyControlsBusy(qtyEl, false);
      }
    });
  });
};

export default initCartLineItemQty;
